import { useConfigStore } from '@/stores';
import { useMemo } from 'react';

export const useCurrentBuilding = () => {
    const currentBuildingId = useConfigStore(state => state?.config?.server?.building?.id);
    const storeBuilding = useConfigStore(state => state?.config?.server?.store?.buildings)

    const currentBuilding = useMemo(() => {
        if (!Array.isArray(storeBuilding)) {
            return null;
        }

        const building = storeBuilding.find((building) => building.id === currentBuildingId);
        return building || null;
    }, [storeBuilding, currentBuildingId]);

    return {
        currentBuilding,
    };
};
